
import React from 'react';
import { Link } from 'react-router-dom';
import { ImageOptimizer } from '@/components/common/ImageOptimizer';

export const Logo: React.FC = () => {
  return (
    <div className="flex items-center">
      <Link to="/">
        <ImageOptimizer 
          src="/lovable-uploads/00525eb1-861d-450e-aded-1102c0cae4e7.png" 
          alt="Cutshort" 
          className="h-8 md:h-10 w-auto"
          width={120} 
          height={40}
          fetchPriority="high"
          loading="eager"
        />
      </Link>
    </div>
  );
};
